<script>
export default {
  props: {
    label: null,
    productId: null,
    productVariantId: null,
    type: null,
    text: null,
    item: null,
    textarea: false,
    placeholder: null,
    loading: false,
    languageId: null,
    languageCode: null,
    id: null,
  },
  data() {
    return {
      textMutable: this.text,
    }
  },
  methods: {
    save() {
      this.$emit('text-edited', {
        productId: this.productId,
        productVariantId: this.productVariantId ?? null,
        text: this.textMutable,
        type: this.type,
        languageId: this.languageId,
        id: this.id,
      });
    }
  }
}
</script>

<template>
  <div class="col-sm-12 form-group">
    <label v-if="this.label !== null">{{ label }}</label>
    <label v-if="this.languageCode !== null">{{ languageCode }}</label>
    <textarea
        v-if="textarea"
        rows="7"
        class="form-control"
        v-model="textMutable"
        @blur="save"
        @keyup.enter="save"
        :disabled="loading"
        :placeholder="placeholder"
    ></textarea>

    <input
        v-else
        type="text"
        class="form-control"
        v-model="textMutable"
        @blur="save"
        @keyup.enter="save"
        :disabled="loading"
        :placeholder="placeholder"
    />
  </div>
</template>
